import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import Countdown from "react-countdown";

import { UserBadge } from "../UserBadge";
import { CountDownRenderer } from "MVVM/Components/CountDownRenderer";
import { useUser } from "MVVM/Hooks/useUser";
import theme from "theme/themeThree";

export const ProForADayStatus = () => {
  const { allstarUser } = useUser();

  const userGroup = allstarUser?.user?.userGroup?.type;
  const expires = allstarUser?.user?.userGroup?.expires;

  if (userGroup !== "PRO" || !expires) {
    return null;
  }

  const expirationDate = new Date(Number(expires));
  const oneDayFromNow = new Date();
  oneDayFromNow.setDate(oneDayFromNow.getDate() + 1);

  if (expirationDate > oneDayFromNow) {
    return null;
  }

  return (
    <Container>
      <BadgeWrapper>
        <UserBadge userGroup="PRO" size="md" />
      </BadgeWrapper>
      <TextContent>
        <ProText>You're Pro!</ProText>
        <TimerText>
          <Countdown
            date={expirationDate}
            renderer={(props) => (
              <CountDownRenderer
                days={props.days}
                hours={props.hours}
                minutes={props.minutes}
                seconds={props.seconds}
                color={theme.colors.premium}
                variant="text.labelSmall"
                showEndsIn={false}
                showIcon={false}
              />
            )}
          />
        </TimerText>
      </TextContent>
    </Container>
  );
};

const Container = styled(Flex)`
  align-items: center;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.premiumAlpha20} 0%,
    ${({ theme }) => theme.colors.envyAlpha20} 100%
  );
  border: 1px solid ${({ theme }) => theme.colors.premiumAlpha40};
  border-radius: 8px;
  gap: 8px;
  padding: 8px 12px;
  width: 100%;
`;

const BadgeWrapper = styled(Flex)`
  align-items: center;
  flex-shrink: 0;
`;

const TextContent = styled(Flex)`
  flex-direction: column;
  flex: 1;
  gap: 4px;
  min-width: 0;
`;

const ProText = styled(Text)`
  color: ${({ theme }) => theme.colors.premium};
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
`;

const TimerText = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
`;
